import '../tables/Table.module.css'
import '../css_styles/button_styles.css'
import classes from '../tables/Table.module.css'

function ObjectiveTableEditor(props) {

    let colGroup = (<>
            <colgroup>
                    <col style={{minWidth:'150px'}} />
                    <col style={{minWidth:'110px'}} />
                    <col style={{minWidth:'90px'}} />
                    <col style={{minWidth:'90px'}} />
                    <col style={{minWidth:'0px'}} />
                    <col style={{minWidth:'150px'}} />
                    <col style={{minWidth:'150px'}} />
                    <col style={{minWidth:'150px'}} />
                    <col style={{minWidth:'150px'}} />
                    <col style={{minWidth:'150px'}} />
                    <col style={{minWidth:'300px'}} />
            </colgroup> 
        </>);

    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                <th>Response Name</th>
                <th>Type</th>
                <th>Unit</th>
                <th>Sub-Score</th>
                <th></th>
                <th>Typical Range</th>
                <th>Go-Criteria</th>
                <th>Target <br/>({'\u25CB'}{'\u25CB'}/{'\u25CB'})</th>
                <th>Okay<br/>({'\u25B3'})</th>
                <th>No-Good<br/><span style={{fontWeight:'300'}}>(x/xx)</span></th>
                <th>Remarks</th>
            </tr>
        </>);


    function input_interval(key_name, key_id, range_min, range_max, inputHandler){
        const interval = (<>
            <div style={{ display:'flex', fontSize: '14px' }}>
                <input 
                id={`${key_name}_min_${key_id}`}
                type='number' 
                placeholder='min' 
                autoComplete='false' 
                value={range_min !== null ? range_min : ''} 
                onChange={inputHandler}
                style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
                <p style={{margin:'0px', padding:'0px', paddingLeft:'5px', paddingRight:'5px', fontSize: '14px'}}>-</p>
                <input 
                id={`${key_name}_max_${key_id}`}
                type='number' 
                placeholder='max'   
                autoComplete='false' 
                value={range_max !== null ? range_max : ''} 
                onChange={inputHandler}
                style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
            </div>
        </>);
    return interval;
    }


    function input_value(key_name, key_id, val, inputHandler){
        const input_field = (<>
            <div style={{ display:'flex', fontSize: '14px' }}>
                <input 
                id={`${key_name}_val_${key_id}`}
                type='number' 
                placeholder='value' 
                autoComplete='false' 
                value={val !== null ? val : ''} 
                onChange={inputHandler}
                style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
            </div>
        </>);
    return input_field;
    }


    function input_csv_list(key_name, key_id, list_vals, inputHandler, onBlurHandler){
        let csv_list = '';
        if (list_vals.length > 0) { 
            csv_list = list_vals.join(', ');
        }
        const csv_input = (<>
            <input 
                id={`${key_name}_${key_id}`}
                type='text' 
                placeholder='csv list ...' 
                autoComplete='false' 
                value={csv_list} 
                onChange={inputHandler}
                onBlur={onBlurHandler}
                style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'143px'}}/>
        </>);
    return csv_input;
    }


    function objective_type(key_name, key_id, type, inputHandler){
        const type_select = (<>
                    <select name='type'
                            className={classes.selectObjectiveEditor}
                            id={`${key_name}_${key_id}`} 
                            onChange={inputHandler}
                            value={type}>
                            <option value='Continuous'>Continuous</option>
                            <option value='Discrete'>Discrete</option>
                    </select>
                </>);
        return type_select;
    }

    function ranking_tier_segment(key_name, key_id, id_segment, segment_data, show_remove, show_add, inputHandler){
        // if all_segments.length > 0
        const selector = (<>
                <select id={`${key_name}_type_${key_id}_${id_segment}`}
                        className={classes.selectObjectiveEditor} 
                        style={{marginRight:'5px'}}
                        value={segment_data.type} 
                        onChange={inputHandler} 
                        name="type">
                    <option value='Interval'>[;]</option>
                    <option value='LE'>{'\u2264'}</option>
                    <option value='L'>{'\u003C'}</option>
                    <option value='GE'>{'\u2265'}</option>
                    <option value='G'>{'\u003E'}</option>
                </select>
            </>);
        
        let input_mask = (<></>);
        if(segment_data.type === 'Interval'){
            let range_min = segment_data.min;
            let range_max = segment_data.max;
            input_mask = input_interval(key_name, `${key_id}_${id_segment}`, range_min, range_max, inputHandler);
        }
        else{
            let val = segment_data.val
            input_mask = input_value(key_name, `${key_id}_${id_segment}`, val, inputHandler);
        }
        
        let add_segment =(<></>);
        if (show_add){
            add_segment = (<>
                    <button 
                            id={`${key_name}_add_${key_id}_${id_segment}`}
                            className={'plus_button'}
                            style={{fontSize:'20px', marginLeft:'5px', marginRight:'5px'}}
                            onClick={inputHandler}>
                    +
                    </button>
                        </>)
        }
        let remove_segment = (<></>);
        if (show_remove){
            remove_segment = (<>
                <button 
                        id={`${key_name}_remove_${key_id}_${id_segment}`}
                        className={'plus_button'}
                        style={{fontSize:'20px', paddingBottom:'5px', marginLeft:'5px',  marginRight:'0px'}}
                        onClick={inputHandler}>
                -
                </button>
                </>)
        }
        const segment = (<>
                    <div key={`${key_name}_${key_id}_${id_segment}`} style={{display:'flex', justifyContent: 'center', alignItems:'center'}}>
                        {selector}
                        {input_mask}
                        {remove_segment}
                        {add_segment}
                    </div>
                          </>);
        return segment
    }


    let tableRows =props.objectives.map((objective, id) => {

        let action_panel = (<></>)
        if((!props.validatedResponses[id] || props.unvalidatedChanges[id]) && (objective.is_score || objective.go_nogo)){
            action_panel = (<>
                            <button 
                                    id={`validation_${id}`}
                                    // className={'actionButtonTiny'}
                                    className={'cellButton'}
                                    style={{marginTop:'3px', marginBottom:'3px'}}
                                    onClick={props.validationHandler}>
                                validate
                            </button>
                         </>);
        }
        // define input for relevant range
        let relevant_range = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
        if(objective.type === 'Continuous' && (objective.is_score === true || objective.go_nogo === true)){
            relevant_range =  input_interval('range_continuous', id, objective.range_continuous.min, objective.range_continuous.max, props.inputHandlerRange)
        }
        if(objective.type === 'Discrete' && (objective.is_score === true || objective.go_nogo === true)){
            relevant_range =  input_csv_list('range_discrete', id, objective.range_discrete.list_vals, props.inputHandlerCSV, props.onBlurCSV)
        }

        // define input for target/okay/no_good/go_nogo
        let target = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
        let okay = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
        let no_good = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
        let go_criteria = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
 

        if (objective.type === 'Continuous' && objective.is_score === true) {
            if (objective.target.length === 0 ){
                    let key_name='target';
                    let key_id = id;
                    let id_segment = -1;
                    target = (<>
                                <button 
                                        id={`${key_name}_add_${key_id}_${id_segment}`}
                                        className={'plus_button'}
                                        style={{fontSize:'20px', marginTop:'4px', marginBottom:'4px', marginLeft:'5px', marginRight:'0px'}}
                                        onClick={props.inputRankingTiers}>
                                +
                                </button>
                            </>);
            }
            else {
                target = []
                for(let i=0; i< objective.target.length; i++)
                {
                    let id_segment = i
                    let show_remove = true;
                    let show_add = false;
                    if(i===objective.target.length-1) {show_add=true;}
                    let segment_data = objective.target[i];
                    target.push(ranking_tier_segment('target', id, id_segment, segment_data, show_remove, show_add, props.inputRankingTiers));
                }
            }

            if (objective.okay.length === 0 ){
                let key_name='okay';
                let key_id = id;
                let id_segment = -1;
                okay = (<>
                            <button 
                                    id={`${key_name}_add_${key_id}_${id_segment}`}
                                    className={'plus_button'}
                                    style={{fontSize:'20px', marginTop:'4px', marginBottom:'4px', marginLeft:'5px', marginRight:'0px'}}
                                    onClick={props.inputRankingTiers}>
                            +
                            </button>
                        </>);
            }
            else {
                okay = []
                for(let i=0; i< objective.okay.length; i++)
                {
                    let id_segment = i
                    let show_remove = true;
                    let show_add = false;
                    if(i===objective.okay.length-1) {show_add=true;}
                    let segment_data = objective.okay[i];
                    okay.push(ranking_tier_segment('okay', id, id_segment, segment_data, show_remove, show_add, props.inputRankingTiers));
                }
            }

            if (objective.no_good.length === 0 ){
                let key_name='nogood';
                let key_id = id;
                let id_segment = -1;
                no_good = (<>
                            <button 
                                    id={`${key_name}_add_${key_id}_${id_segment}`}
                                    className={'plus_button'}
                                    style={{fontSize:'20px', marginTop:'4px', marginBottom:'4px', marginLeft:'5px', marginRight:'0px'}}
                                    onClick={props.inputRankingTiers}>
                            +
                            </button>
                        </>);
            }
            else {
                no_good = []
                for(let i=0; i< objective.no_good.length; i++)
                {
                    let id_segment = i
                    let show_remove = true;
                    let show_add = false;
                    if(i===objective.no_good.length-1) {show_add=true;}
                    let segment_data = objective.no_good[i];
                    no_good.push(ranking_tier_segment('nogood', id, id_segment, segment_data, show_remove, show_add, props.inputRankingTiers));
                }
            }
        }

        if (objective.type === 'Discrete' && objective.is_score === true) {
            let target_list_vals = []
            if (objective.target.length >0 ){
                target_list_vals = objective.target[0].list_vals;
            }
            let okay_list_vals = []
            if (objective.okay.length >0 ){
                okay_list_vals = objective.okay[0].list_vals;
            }
            let no_good_list_vals = []
            if (objective.no_good.length >0 ){
                no_good_list_vals = objective.no_good[0].list_vals;
            }
            target = input_csv_list('target', id, target_list_vals, props.inputHandlerCSV, props.onBlurCSV)
            okay = input_csv_list('okay', id, okay_list_vals, props.inputHandlerCSV, props.onBlurCSV)
            no_good = input_csv_list('no_good', id, no_good_list_vals, props.inputHandlerCSV, props.onBlurCSV)
        }



        if (objective.type === 'Continuous' && objective.go_nogo === true) {

            if (objective.go_criteria.length === 0 ){
                let key_name='gocriteria';
                let key_id = id;
                let id_segment = -1;
                go_criteria = (<>
                            <button 
                                    id={`${key_name}_add_${key_id}_${id_segment}`}
                                    className={'plus_button'}
                                    style={{fontSize:'20px', marginTop:'4px', marginBottom:'4px', marginLeft:'5px', marginRight:'0px'}}
                                    onClick={props.inputRankingTiers}>
                            +
                            </button>
                        </>);
            }
            else {
                go_criteria = []
                for(let i=0; i< objective.go_criteria.length; i++)
                {
                    let id_segment = i
                    let show_remove = true;
                    let show_add = false;
                    if(i===objective.go_criteria.length-1) {show_add=true;}
                    let segment_data = objective.go_criteria[i];
                    go_criteria.push(ranking_tier_segment('gocriteria', id, id_segment, segment_data, show_remove, show_add, props.inputRankingTiers));
                }
            }

        }

        if (objective.type === 'Discrete' && objective.go_nogo === true) {
            let go_criteria_list_vals = []
            if (objective.go_criteria.length >0 ){
                go_criteria_list_vals = objective.go_criteria[0].list_vals;
            }
            go_criteria = input_csv_list('go_criteria', id, go_criteria_list_vals, props.inputHandlerCSV, props.onBlurCSV)
        }


        return (
            <tr key={`row_${id}`}>
                <td key={`name_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}>
                        {objective.name}
                    </div>
                </td>
                <td key={`type_${id}`} style={{verticalAlign: 'top'}}>
                    {objective_type('type', id, objective.type, props.inputHandlerType)}
                </td>
                <td key={`units_${id}`} style={{verticalAlign: 'top'}}>
                    <input 
                        id={`units_${id}`} 
                        type='text' 
                        placeholder='Enter units ...' 
                        autoComplete='false' 
                        value={objective.units} 
                        onChange={props.inputHandlerUnits}
                        style={{fontSize: '14px'}}
                        />
                </td>
                <td key={`is_score_${id}`} style={{verticalAlign: 'top'}}>
                    <input 
                        id={`is_score_${id}`} 
                        style={{marginTop:'5px'}}
                        onChange={props.inputHandlerScore} 
                        type='checkbox' 
                        checked={objective.is_score}
                    />
                </td>
                <td key={`actionpanel_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}>
                        {action_panel}
                    </div>
                </td>
                <td key={`range_${id}`} style={{verticalAlign: 'top'}}>
                    {relevant_range}
                </td>
                <td key={`go_criteria_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {go_criteria}
                    </div>
                </td>
                <td key={`target_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {target}
                    </div>
                </td>
                <td key={`okay_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {okay}
                    </div>
                </td>
                <td key={`no_good_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {no_good}
                    </div>
                </td>
                <td key={`remarks_${id}`} style={{verticalAlign: 'top'}}>
                    <input 
                        id={`remarks_${id}`} 
                        type='text' 
                        placeholder='Enter remarks ...' 
                        autoComplete='false' 
                        value={objective.remarks} 
                        onChange={props.inputHandlerRemarks}
                        style={{fontSize: '14px'}}
                        />
                </td>
            </tr>
        );
    });




    return(<>
        <table style={{marginBottom:'5px'}}>
        {colGroup}
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={10}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default ObjectiveTableEditor;
